const mapping = {
  dog: 'cf-dog',
  hund: 'cf-dog',
  cat: 'cf-cat',
  katze: 'cf-cat',
}

const sortOrder = {
  'cf-dog': 0,
  'cf-cat': 1,
}

export default function getAnimalIcons(animals) {
  const input = Array.isArray(animals) ? animals : [animals] // Ensure we have an array
  return input
    .map((a) => mapping[a?.toLowerCase?.()]) // Only add known icons
    .filter(Boolean) // Remove undefined values
    .filter((v, i, arr) => arr.indexOf(v) === i) // Filter duplicates
    .sort((a, b) => sortOrder[a] - sortOrder[b]) // Sort
}
